import React, { FC, useMemo } from 'react';
// import ReactQuill from 'react-quill';
import Utils from '../../utils/Utils';
import 'react-quill/dist/quill.snow.css';
import { TextBlock } from '../uicomp/atmos/content-block/ContentBlock';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './RichText.module.less';

import ReactQuill from 'react-quill';

type Props = {
  onChange?: (value?: any) => void;
  value?: any;
  maxLength?: number;
  onFocus?: () => void;
  onBlur?: (value?: any) => void;
  placeholder?: string;
};
export const RichText: FC<Props> = (props) => {
  const formats = useMemo(
    () => [
      // 'header',
      'bold',
      'italic',
      'underline',
      // 'strike',
      'list',
      'bullet',
      'indent',
      'link',
      // 'color',
      // 'background',
    ],
    [],
  );
  const modules = useMemo(
    () => ({
      toolbar: [
        // [{ header: [3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline'],
        // [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['link'],
        ['clean'],
      ],
    }),
    [],
  );
  const p = Utils.useOmitFields(props, 'value', 'onChange');

  // const checkCharacterCount = (event: { key: string; preventDefault: () => void }) => {
  //   // const unprivilegedEditor = reactQuillRef.current.unprivilegedEditor;
  //   if (props.value?.length > (props.maxLength ?? 1000000) && event.key !== 'Backspace')
  //     event.preventDefault();
  // };
  return (
    <div onBlur={props?.onBlur}>
      <ReactQuill
        // onKeyDown={checkCharacterCount}
        modules={modules}
        value={props.value ? (props.value as string) : ''}
        onChange={(content: any) => props.onChange && props.onChange(content)}
        onFocus={() => props.onFocus && props.onFocus()}
        placeholder={props.placeholder ? (props.placeholder as string) : ''}
        formats={formats}
        {...p}
      />
      {(props.maxLength
        ? props.maxLength - (props.value?.length ?? 0) + 1
        : props.value?.length ?? 0) < 0 && (
        <TextBlock align={'right'} className={styles.richTextCount} secondary level={-2}>
          {props.maxLength
            ? `${props.maxLength - (props.value?.length ?? 0) + 1}`
            : `${props.value?.length ?? 0}`}
        </TextBlock>
      )}
    </div>
  );
};
